import { useCallback } from 'react';
import useRecaptchaV3 from './useRecaptchaV3';
import { localhostname } from '.';
import authService from 'src/services/api/auth';

export const RECAPTCHA_SECURITY_ERROR = 'Disculpa, hubo un error, por favor intenta de nuevo.';

/**
 * Captcha is required when not on localhost AND the user is either
 * not logged in or has a profile other than 1 (admin).
 */
export const isCaptchaRequired = () => {
  if (typeof window === 'undefined' || window.location.hostname === localhostname) {
    return false;
  }

  return authService.getCurrentUser()?.profile !== 1;
};

/**
 * Returns an async function that resolves a reCAPTCHA v3 token for API calls.
 * Skips execution when captcha is not required (returns 'localhost_skip').
 *
 * @param {string} action - reCAPTCHA action name (e.g. 'login', 'guest_login')
 * @returns {(options?: { skip?: boolean }) => Promise<string|null>}
 */
export const useRecaptchaToken = (action = 'submit') => {
  const { getRecaptchaToken } = useRecaptchaV3();

  return useCallback(
    async ({ skip = false } = {}) => {
      if (skip || !isCaptchaRequired()) {
        return 'localhost_skip';
      }

      return getRecaptchaToken(action);
    },
    [getRecaptchaToken, action]
  );
};
